import { Card, CardContent, CardHeader, FormControl, FormControlLabel, FormHelperText, Grid2, IconButton, Stack, Switch } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import { useNavigate, useSearchParams } from "react-router-dom";
import MaterialTypography from "../../../components/MaterialTypography";
import { ArrowBack } from "@mui/icons-material";
import MaterialBox from "../../../components/MaterialBox";
import { useInsurerBranchFormHandling } from "./components/InsurerBranchStateHandle";
import MaterialSelect from "../../../components/MasterSelect";
import MaterialInput from "../../../components/MaterialInput";
import { useEffect, useState } from "react";
import MaterialButton from "../../../components/MaterialButton";
import { fetchData, fetchDataById, postData, putData } from "../../../services";
import { useLoading } from "../../../components/Loading";
import { useSnackbar } from "../../../context/popup";

const InsurerBranchForm = () => {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { setCircleLoading } = useLoading();
    const {showSnackbar} = useSnackbar();
    const branchId = searchParams.get("id");
    const pageType = searchParams.get("pageType");
    const pageMode = pageType === "view" ? "view" : pageType === "edit" 
            ? "edit" : "add";
    const [generalInsurerOptions, setGeneralInsurerOptions] = useState([]);
    const [insurerBankOptions,setInsurerBankOptions] = useState([]);
    const [generalBranchOptions, setGeneralBranchOptions] = useState([]);

    useEffect(() => {
        if (pageMode === "add" || !branchId) {
            return;
        }
        //Fetch data by Pincode Id
        const fetchBankRranchById = async (branchId) => {
            setCircleLoading(true);
            try {
            const response = await fetchDataById(`/reference/insurer/bank-branch/${branchId}`);

            const responseData = response?.data?.branch;
            
            if (response.success) {
                const mapped = {
                    name: responseData?.name || "",
                    code: responseData?.code || "",
                    branchCode: responseData?.branchCode || "",
                    gBankBranch: { label :responseData?.gBankBranchId, value: responseData?.gBankBranchId },
                    iBank: {label: responseData?.iBankId, value: responseData?.iBankId},
                    gInsurer: {label: responseData?.gInsurerName, value: responseData?.gInsurerId},
                    isActive: responseData?.isActive,
                    // reset status fields
                    nameStatus: responseData?.name ? "success" : "unchecked",
                    codeStatus: responseData?.code ? "success" : "unchecked",
                    branchCodeStatus: responseData?.branchCode ? "success" : "unchecked",
                    gBankBranchStatus: responseData?.gBankBranchId ? "success" : "unchecked",
                    gInsurerStatus: responseData?.gInsurerId ? "success" : "unchecked",
                    iBankStatus: responseData?.iBankId ? "success" : "unchecked",

                };

                setFormData(mapped);  
            }
            } catch (error) {
                console.error("Error fetching data by ID:", error);
                showSnackbar(error?.response?.data?.message || "Error fetching data by ID","error");
            }
            finally{
                setCircleLoading(false);
            }
        };
        fetchBankRranchById(branchId);
    }, [pageMode]);

    useEffect(() => {
        if(pageMode === 'view'){
            return
        }
        fetchAllDropdowns();
    }, []);

     //all dropdown api function
    const fetchAllDropdowns = async () => {
        setCircleLoading(true);

        try {
            const [
            insurerResponse,
            branchResponse,
            bankResponse,
            ] = await Promise.all([
            fetchData(`/reference/general/insurer-master?dropdown=true&isActive=true`),
            fetchData(`/reference/general/branch?dropdown=true&isActive=true`),
            fetchData(`/reference/insurer/bank?dropdown=true&isActive=true`),
            ]);

            const formattedInsurers = insurerResponse?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.companyName,
            })) || [];

            const formattedBranches = branchResponse?.data?.items?.map((item) => ({
                value: item?.branch?.id,
                label: item?.branch?.name,
            })) || [];

            const formattedBanks = bankResponse?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.name,
            })) || [];
            
            setGeneralInsurerOptions(formattedInsurers);
            setGeneralBranchOptions(formattedBranches);
            setInsurerBankOptions(formattedBanks);

        } catch (error) {
            console.error("Error fetching dropdown data:", error);
            showSnackbar("Error fetching dropdown data","warning");
        } finally {
            setCircleLoading(false);
        }
    };

    //post and put api function
    const handleSubmitBranch = async () => {
        const payload = {
            // id: branchId,    //to be changed in api while updating
            gInsurerId: formData?.gInsurer?.value,
            gBankBranchId: formData?.gBankBranch?.value,
            iBankId: formData?.iBank?.value,
            name: formData?.name,
            code: formData?.code,
            branchCode: formData?.branchCode,
            isActive: formData?.isActive,
        };
        //Update
        if(branchId){
            try {
                setCircleLoading(true);
                const response = await putData(`/reference/insurer/bank-branch/${branchId}`, payload);
                const responseMessage = response?.message;
                if(response?.success){
                //success message
                    showSnackbar(responseMessage,"success");
                    navigate('/insurer-master/insurer-branch');          
                }
                else{
                    //error message
                    showSnackbar(responseMessage,"error")
                }
            } catch (error) {
                console.error('Error updating data:', error);
                showSnackbar(error?.response?.data?.message, "error");
            }
            finally{
                setCircleLoading(false);
            }
        }
        else{      
        //Submit
        try {
            const response = await postData('/reference/insurer/bank-branch', payload);
            const responseMessage = response?.message;
            if(response?.success){
                //success message
                showSnackbar(responseMessage,"success");
                navigate('/insurer-master/insurer-branch');          
            }
            else{
                //error message
                showSnackbar(responseMessage,"error")
            }
        } catch (error) {
            console.error('Error posting data:', error);
            showSnackbar(error?.response?.data?.message, "error");
            //catch error message
        }
        }
    };

    const { formData, setFormData, handleChange, checkAllFields } = useInsurerBranchFormHandling(); 

  return (
    <DashboardLayout>
        <Card sx={{ minHeight: 500 }}>
            <CardHeader
            title={(
                <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
                >
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <IconButton onClick={() => navigate("/insurer-master/insurer-branch")}>
                            <ArrowBack />
                        </IconButton>
                        <Stack direction="column" spacing={0}>
                        <MaterialTypography variant="h5" fontWeight="medium">
                            Insurer Bank Branch Details
                        </MaterialTypography>
                        <MaterialTypography variant="caption" color="text">
                            Enter New Bank Branch Details to Insurer.
                        </MaterialTypography>
                        </Stack>
                    </Stack>
                </Stack>
            )}
            />
            <CardContent>
                <Grid2 container spacing={2}>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                General Insurer
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        name="gInsurer"
                        value={formData.gInsurer}
                        onChange={handleChange}
                        options={generalInsurerOptions}
                        success={formData.gInsurerStatus === "success"}
                        error={formData.gInsurerStatus === "error"}
                        isDisabled={pageMode === "view"}
                        />
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                General Bank Branch
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        name="gBankBranch"
                        value={formData.gBankBranch}
                        onChange={handleChange}
                        options={generalBranchOptions}
                        success={formData.gBankBranchStatus === "success"}
                        error={formData.gBankBranchStatus === "error"}
                        isDisabled={pageMode === "view"}
                        />
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Insurer Bank
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        name="iBank"
                        value={formData.iBank}
                        onChange={handleChange}
                        options={insurerBankOptions}
                        success={formData.iBankStatus === "success"}
                        error={formData.iBankStatus === "error"}
                        isDisabled={pageMode === "view"}
                        />
                    </Grid2>                   
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Bank Branch Name
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        success={formData.nameStatus === "success"}
                        error={formData.nameStatus === "error"}
                        disabled={pageMode === "view"}
                        />
                        {formData.nameStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                Bank Branch Name should be a minimum 1 character & maximum 100
                                characters long.
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Code
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                        name="code"
                        value={formData.code}
                        onChange={handleChange}
                        success={formData.codeStatus === "success"}
                        error={formData.codeStatus === "error"}
                        disabled={pageMode === "view"}
                        />
                        {formData.codeStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                Code should be a minimum 1 character & maximum 20
                                characters long.
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid2>
                     <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Branch Code
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                        name="branchCode"
                        value={formData.branchCode}
                        onChange={handleChange}
                        success={formData.branchCodeStatus === "success"}
                        error={formData.branchCodeStatus === "error"}
                        disabled={pageMode === "view"}
                        />
                        {formData.branchCodeStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                Bank Branch Code should be a minimum 1 character & maximum 20
                                characters long.
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Actve
                            </MaterialTypography>
                        </MaterialBox>
                        <FormControlLabel
                        control={
                            <Switch
                                checked={formData.isActive}
                                disabled={pageMode === "view"}
                                onChange={(e) =>
                                    handleChange({
                                        target: {
                                            name: "isActive",
                                            value: e.target.checked,
                                        },
                                    })
                                }
                                color="primary"
                            />
                        }
                        label={
                            <MaterialTypography variant="caption" fontWeight="bold">
                                {formData?.isActive ? "Yes" : "No"}
                            </MaterialTypography>
                        }
                        sx={{ marginLeft: 0 }}
                        />
                    </Grid2>
                </Grid2>
            </CardContent>
            <MaterialBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            >
                {pageMode !== "view" && (
                <>
                    <MaterialButton
                    sx={{ m: 2 }}
                    variant="outlined"
                    color="dark"
                    onClick={() => navigate("/insurer-master/insurer-branch")}
                    >
                    Cancel
                    </MaterialButton>
                    <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    disabled={!checkAllFields()}
                    onClick={handleSubmitBranch}
                    >
                    {pageMode === "edit" ? "Update" : "Submit"}
                    </MaterialButton>
                </>
                )}
            </MaterialBox>
        </Card>
    </DashboardLayout>
  )
}

export default InsurerBranchForm